module.exports = __webpack_public_path__ + "static/media/NSS3.fb593372.jpg";